import { BlogSection } from "@/types/blog";

export const quellen: BlogSection = {
  id: "quellen",
  title: "Quellen",
  content: `
    <ul>
      <li>Edmondson, <em>The Fearless Organization</em></li>
      <li>Deci & Ryan, <em>Self-Determination Theory</em></li>
      <li>Goleman, <em>Emotional Intelligence</em></li>
      <li>Rock, <em>SCARF Model</em></li>
      <li>Schein, <em>Organizational Culture and Leadership</em></li>
    </ul>
  `
};
